import React from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";

import HomePage from "./page/home";
import Room from "./page/room";
import Notfound from "./page/notfound";

// หน้าเป็น class component ใช้ hook ไม่ได้ — ห่อด้วยตัวนี้แล้วส่ง navigate/location ลงไปเป็น props
const HomeRoute = () => <HomePage navigate={useNavigate()} location={useLocation()} />;

// ★ key = query string : กดทรัพย์ใกล้เคียง (/room → /room อีกห้อง) เป็น route เดิม
//   ถ้าไม่ใส่ key React จะใช้คอมโพเนนต์ตัวเดิมต่อ state ห้องเก่าค้าง ไม่โหลดห้องใหม่
const RoomRoute = () => {
  const location = useLocation();
  return <Room key={location.search} navigate={useNavigate()} location={location} />;
};

const AppRoutes = () => (
  <Routes>
    {/* ★ ใช้ Navigate แทนการสั่ง window.location.href ใน componentDidMount
        ของเดิมโหลดหน้าเว็บใหม่ทั้งหน้า 2 รอบก่อนจะเห็นอะไร */}
    <Route path="/" element={<Navigate to="/overview" replace />} />

    <Route path="/overview" element={<HomeRoute />} />

    {/* รายละเอียดห้อง — /room?project=<project_id>&uid=<listing_uid> */}
    <Route path="/room" element={<RoomRoute />} />

    <Route path="*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
